import type { I18nLocale } from '#/i18n/types/I18nLocale';

import { postOnIdealistDropdownDataEn } from './postOnIdealistDropdownData.en';
import { postOnIdealistDropdownDataEs } from './postOnIdealistDropdownData.es';
import type { PostOnIdealistDropdownData } from './types/PostOnIdealistDropdownData';

export const postOnIdealistDropdownDataByLocale: Record<
  I18nLocale,
  PostOnIdealistDropdownData
> = {
  en: postOnIdealistDropdownDataEn,
  es: postOnIdealistDropdownDataEs,
};
